import { GetTreePath, TreeOptions } from '../types/grid';
import { GridRef } from '../types/refs';

export function tree<TRow extends object>(
  ref: GridRef<TRow>,
  dataPath: GetTreePath<TRow>,
  options: TreeOptions<TRow> | undefined = undefined): void {
  ref.makeTree(dataPath, options);
}
